var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.99935 27.3334C3.08268 27.3334 2.29796 27.007 1.64518 26.3542C0.992405 25.7015 0.666016 24.9167 0.666016 24.0001V19.0001H3.99935V24.0001H23.9993V19.0001H27.3327V24.0001C27.3327 24.9167 27.0063 25.7015 26.3535 26.3542C25.7007 27.007 24.916 27.3334 23.9993 27.3334H3.99935ZM12.3327 20.6667V7.08342L7.99935 11.4167L5.66602 9.00008L13.9993 0.666748L22.3327 9.00008L19.9993 11.4167L15.666 7.08342V20.6667H12.3327Z",
  fill: "#597EF7"
})));
export default __webpack_public_path__ + "teg/media/upload-new.7b995906.svg";
export { SvgComponent as ReactComponent };